import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { setSelectedData } from 'store/slices';
import { membershipType } from 'utils/constants';
import { getDataFromLocalStorage, getUserType } from 'utils/helpers';
import Button from 'components/form/Button';
import Modal from 'components/Layout/Modal';
import Table from 'components/Layout/Table';

const UserAddOnServicesModal = ({ onHide, addOnServicesData }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedIds, setSelectedIds] = useState([]);
  // const [inrPrice, setINRPrice] = useState('');
  const [userIsFree, setUserIsFree] = useState(false);
  const useDetails = getDataFromLocalStorage();
  const memberType = getUserType();
  const params = useParams();
  const { moduleType, eventId } = params;

  const {
    user_type,
    membership_plan_id,
    personal_details = {},
    institution_details = {},
    exchange_rate,
  } = useDetails;
  const isPremiumMember = [3, 12].includes(membership_plan_id);
  const isFreeMember = [2, 11].includes(membership_plan_id);

  const { inrPrice } = useSelector((state) => ({ inrPrice: state.currency.inrPrice }));
  const inrValue = inrPrice || exchange_rate

  const findType = membershipType.find((o) => o.id === user_type)?.type || '';
  let { country: userCountry, country_name: countryName } = personal_details;
  let { country_name: iCountryName } = institution_details;
  const isNational =
    countryName === 'India' ||
    iCountryName === 'India' ||
    ['0', '6'].includes(user_type);

  const handleCheckboxChange = (id, isChecked) => {
    setSelectedIds((prevSelected) =>
      isChecked
        ? [...prevSelected, id]
        : prevSelected.filter((item) => item !== id)
    );
  };

  // const fetchUSDPrice = () => {
  //   fetch(`https://api.exchangerate-api.com/v4/latest/USD`)
  //     .then((response) => {
  //       return response.json();
  //     })
  //     .then((data) => {
  //       // setUSDPrice(data?.rates["USD"]);
  //       setINRPrice(1 / data?.rates['INR']);
  //     })
  //     .catch(() => {
  //       setINRPrice(1 / exchange_rate);
  //     });
  // };

  const header = [
    {
      title: <div className="text-nowrap">Addons Section</div>,
    },
    {
      title: <div className="text-nowrap">Free</div>,
    },
    {
      title: <div className="text-nowrap">Premium</div>,
    },
  ];

  const rowData = addOnServicesData?.services?.map(
    ({ id, category, free_member, premium_member }) => {
      const updatedFreeMember = isNational
        ? free_member
        : (free_member / inrValue).toFixed(2);

      const updatedPremiumMember = isNational
        ? premium_member
        : (premium_member / inrValue).toFixed(2);

      return {
        data: [
          {
            value: (
              <div className="d-flex">
                <input
                  type="checkbox"
                  className={`custom-checkbox ${selectedIds.includes(id)
                      ? 'activeChecked'
                      : 'activeUnchecked'
                    }`}
                  onChange={(e) => handleCheckboxChange(id, e.target.checked)}
                  checked={selectedIds.includes(id)}
                />
                <span className="ms-2 text-center w-100">{category}</span>
              </div>
            ),
          },
          {
            value: (
              <div className="text-nowrap text-14-300-18">
                {`${isNational ? '₹' : '$'} ${updatedFreeMember}` || '-'}
              </div>
            ),
          },
          {
            value: (
              <div className="text-nowrap text-14-300-18">
                {`${isNational ? '₹' : '$'} ${updatedPremiumMember}` || '-'}
              </div>
            ),
          },
        ],
      };
    }
  );

  const handleApprove = () => {
    const selectedData = addOnServicesData?.services?.filter(({ id }) =>
      selectedIds.includes(id)
    );

    if (isFreeMember) {
      setUserIsFree(true);
      localStorage.isRedirectToRegister = 1;
      localStorage.prevRoute = window.location.pathname;
      dispatch(setSelectedData(selectedData));
    } else {
      dispatch(setSelectedData(selectedData));
      localStorage.isRedirectToRegister = 1;
      localStorage.prevRoute = window.location.pathname;
      navigate(
        `/${memberType}/${moduleType}/event-details/${eventId}/conference-details`
      );
    }
  };

  // useEffect(() => {
  //   fetchUSDPrice();
  // }, []);

  return (
    <Modal
      titleBesideClose="Add-On Services"
      onHide={onHide}
      isTitleBorder
      isTitleVerticalCenter
    >
      {userIsFree ? (
        <>
          <div className="cps-20 cpe-20 cpb-10 cpt-10">
            <p className="text-16-400">
              Are you sure want to continue with Free ?
            </p>
            <div className="cmt-30 d-flex gap-3 align-items-center">
              <Button
                btnStyle="primary-dark"
                text="Go with Premium"
                className="h-35 text-14-500 text-nowrap w-auto px-3"
                type="submit"
                onClick={() => {
                  navigate(`/${findType}/renew`);
                }}
              />

              <Button
                btnStyle="light-outline"
                text="Continue with Free"
                className="h-35 text-14-500 text-nowrap w-auto px-3"
                type="button"
                onClick={() => {
                  navigate(
                    `/${memberType}/${moduleType}/event-details/${eventId}/conference-details`
                  );
                }}
              />
            </div>
          </div>
        </>
      ) : (
        <div className="cps-20 cpe-20 cpb-10 cpt-10">
          <Table header={header} rowData={rowData} />
          <div className="mt-3 d-flex gap-3 cmt-20 align-items-center">
            <Button
              btnStyle="primary-dark"
              text="Proceed Next"
              className="h-35 text-14-500 text-nowrap w-auto px-3"
              type="submit"
              onClick={handleApprove}
              disabled={selectedIds?.length === 0}
            />

            <Button
              btnStyle="light-outline"
              text="Back"
              className="h-35 text-14-500 text-nowrap w-auto px-3"
              type="button"
              onClick={() => {
                onHide();
                navigate(-1);
              }}
            />
          </div>
        </div>
      )}
    </Modal>
  );
};

export default UserAddOnServicesModal;
